import { alpha, styled, Switch, SwitchProps } from '@mui/material';
import React from 'react';

const THUMB_SIZE = 48;

const StyledSwitch = styled(Switch, {
    shouldForwardProp: prop => prop !== 'loading',
})<{ loading?: boolean }>(({ theme, checked, loading }) => ({
    width: 87,
    height: 51,
    padding: 7,
    '@keyframes large-switch-thumb-spin': {
        to: {
            transform: 'rotate(360deg)',
        },
    },
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(6px)',
        '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(38px)',
        },
    },
    '& .MuiSwitch-thumb': {
        width: THUMB_SIZE,
        height: THUMB_SIZE,
        backgroundColor: checked ? theme.palette.success.dark : theme.palette.warning.light,
        boxShadow: theme.shadows[1],
        '&::after': {
            content: loading ? '""' : checked ? '"ON"' : '"OFF"',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            textAlign: 'center',
            color: checked ? theme.palette.common.white : theme.palette.common.black,
            fontSize: 16,
            fontWeight: 'bold',
            lineHeight: `${THUMB_SIZE}px`,
        },
        ...(loading && {
            '&::before': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: 22,
                height: 22,
                marginTop: -11,
                marginLeft: -11,
                borderRadius: '50%',
                border: `2.5px solid ${alpha(checked ? theme.palette.common.white : theme.palette.common.black, 0.25)}`,
                borderTopColor: checked ? theme.palette.common.white : theme.palette.common.black,
                animation: 'large-switch-thumb-spin 0.75s linear infinite',
                boxSizing: 'border-box',
            },
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: THUMB_SIZE / 2,
    },
}));

export type LargeMaterialUISwitchProps = SwitchProps & {
    loading?: boolean;
};

export const LargeMaterialUISwitch = React.forwardRef<HTMLButtonElement, LargeMaterialUISwitchProps>(function LargeMaterialUISwitch(
    { loading = false, disabled, onChange, ...props },
    ref,
) {
    return (
        <StyledSwitch
            ref={ref}
            loading={loading}
            disabled={disabled}
            onChange={loading ? undefined : onChange}
            sx={{
                ...(loading && {
                    pointerEvents: 'none',
                }),
            }}
            {...props}
        />
    );
});

export default LargeMaterialUISwitch;
